import { Component, OnInit } from '@angular/core';
import { BaseComponent } from '../base/base.component';
import { BoxMessage } from '../../models/boxmessage';

@Component({
  selector: 'app-dni-state',
  templateUrl: './dni-state.component.html',
  styleUrls: ['./dni-state.component.scss']
})
export class DniStateComponent extends BaseComponent implements OnInit {
  openCode:boolean = false;
  order:any;
  box_name:string;
  products:string;
  inputCode:any = "";
  codeLength:number = 3;
  poll:any;
  subscription:any;
  errorCode:boolean = false;

  ngOnInit(): void {
    // this.order = {
    //   'client': {
    //     'nickname': 'asddsa'
    //   },
    //   'actual_device': {
    //     'name': '1'
    //   },
    //   'unlock_type': 'code',
    //   'unlock_code': '123456789'
    // }

  	var device_info = this.localSession.getDeviceInfo();
  	this.order = this.localSession.getOrder();
    this.box_name = this.order.actual_device.name;
    // this.products = this.order.order_details.map( (od) => od.product.name ).join(",");

    if (this.order.unlock_type == 'code' && this.order.unlock_code) {
	    this.openCode = true;
	    this.codeLength = this.order.unlock_code.length;
    }else if(this.order.unlock_type == 'app'){
		this.openCode = false;
    }else{
    	console.log("No debería llegar acá");
    }

    this.subscription = this.boxService.getMessages()
        .subscribe((msg: BoxMessage) => { 

        	this.poll = this.localSession.getPoll();
        	
        	if (msg.action == 'status' && msg.params == 'opened') {
		  		if (this.poll) {
					this.router.navigate(['/Poll']);
				}else{
					this.router.navigate(['/IdleStateComponent']);
				}
        	}

    });
  }

  setNumber(number:any){
    if (this.inputCode.length < this.order.unlock_code.length) {
      this.inputCode += number;
    }
  }

  delNumber(){
    this.inputCode = this.inputCode.substr(0,this.inputCode.length -1);
  }

  validCode():boolean{
    return this.inputCode.length == this.order.unlock_code.length;
  }

  checkCode(){
    // if (this.validCode()) {
    	if (this.inputCode == this.order.unlock_code) {
    		this.boxService.setOrderDone();
    	}else{
        this.errorCode = true;

        setTimeout(() => {
          this.errorCode = false;
        }, 3000);
      }
    // }
  }

  ngOnDestroy(){
    this.subscription.unsubscribe();
  }

}
